var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-container',[_c('kst-section',{attrs:{"list-mode":"","title":_vm.Info.Section.PackagingList.Title}},[_c('kst-load-data',{attrs:{"activeOnLoad":"","loadingElement":""},on:{"init":_vm.handleLoad_init}},[_c('List',{attrs:{"dataList":_vm.dataList}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }